import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import PromptGallery from '../Components/Pages/PromptGallery';
// import Dashboard from '../Components/Dashboard/dashboard_old';
// import Dashboard from '../Components/Dashboard/dashboard';
// import Builder from '../Components/Builder/builder';
import LivePreview from '../Components/Live/LivePreview';
import Protected from '../services/Auth';
import DashboardProtected from '../services/DashboardAuth';
import NotFoundPage from '../utils/HelperComponents/NotFoundPage';
import PrivacyPolicy from '../Components/Pages/PrivacyPolicy';
import GlobalPrivacyPolicy from '../Components/Pages/GlobalPrivacyPolicy';
import TermsService from '../Components/Pages/TermsService';
import CookiePolicy from '../Components/Pages/CookiePolicy';
import UserPLanInfo from '../Components/Dashboard/SubComponents/my-profile/UserPlanInfo';
import Subscription from  '../Components/userPlanINfo/Subscription';
// import SignUp from '../Components/Auth/SignUp';
import SignUp from '../Components/Auth/SignUp';
import LoginWrapper from '../Components/Auth/LoginWrapper';
import VerifyEmail from '../Components/Auth/VerifyEmail';
import CreatePassword from '../Components/Auth/CreatePassword';
import Verification from '../Components/Auth/Verification';
import ForgotPassword from '../Components/Auth/ForgotPassword';
import ResetPassword from '../Components/Auth/ResetPassword';
import PurchasingPLan from '../Components/Dashboard/SubComponents/payment-plan/PurchasingPlan';
import Plan from '../Components/Dashboard/SubComponents/payment-plan/Plan';
import GeneralSettings from '../Components/Dashboard/SubComponents/my-profile/GeneralSettings';
import Billing from '../Components/Dashboard/SubComponents/my-profile/Billing';
import { Sub } from '@radix-ui/react-context-menu';
import DisplayUserPlanDetails from '../Components/userPlanINfo/DisplayUserPlanDetails';
import { useUserDetails } from '../../redux/hooks/UserDetails';
import ImageGenerator from '../Components/Builder/AI-Agent/ImageGenerator';
import ImageEditor from '../Components/Builder/AI-Agent/ImageEditor';
const BuilderComponent = lazy(() =>
  new Promise<{ default: React.ComponentType<any> }>((resolve) => {
    setTimeout(() => resolve(import("../Components/Builder/builder")), 300);
  })
);

const PreviewComponent = lazy(() =>
  new Promise<{ default: React.ComponentType<any> }>((resolve) => {
    setTimeout(() => resolve(import("../Components/Preview/Preview")), 300);
  })
);


const DashboardComponent = lazy(() =>
  new Promise<{ default: React.ComponentType<any> }>((resolve) => {
    setTimeout(() => resolve(import("../Components/Dashboard/dashboard")), 300);
  })
);
const LiveComponent = lazy(() =>
  new Promise<{ default: React.ComponentType<any> }>((resolve) => {
    setTimeout(() => resolve(import("../Components/Live/LivePreview")), 300);
  })
);

const RestrictedRoute = ({ component: Component }: { component: React.ComponentType }) => {
  const { userDetail } = useUserDetails();
  return !userDetail?.ogUserId ? <Component /> : <NotFoundPage />;
};

const DomainCheck = ({ children }: { children: React.ReactNode }) => {
  const currentDomain = window.location.hostname;
  if (currentDomain === 'autoolic.outgrow.co' || currentDomain === 'ai-tool-builder.web.app') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

const routes: RouteObject[] = [
  { path: "/", element: <DashboardProtected><DashboardComponent /></DashboardProtected> },
  { path: "/ai-agent/ai-img-generator", element: <DashboardProtected><ImageGenerator/></DashboardProtected> },
  { path: "/ai-agent/ai-img-editor", element: <DashboardProtected><ImageEditor/></DashboardProtected> },
  { path: "/prompt-gallery", element:  <DashboardProtected><PromptGallery /></DashboardProtected>},
  { path: "/builder/:url", element: <Protected><BuilderComponent /></Protected> },
  { path: "/preview", element: <Protected><PreviewComponent /></Protected> },
  { path: "/live/:liveUrl", element: <LiveComponent /> },
  { path: "/privacy-policy", element:<DashboardProtected><PrivacyPolicy /></DashboardProtected> },
  { path: "/global-privacy-policy", element:<DashboardProtected><GlobalPrivacyPolicy /> </DashboardProtected> },
  { path: "/terms-of-service", element:<DashboardProtected><TermsService /> </DashboardProtected> },
  { path: "/plan", element:<Protected><PurchasingPLan /></Protected> },
  // { path: "/planTest", element:<Protected><Plan /></Protected> },
  { path: "/planinfo", element:<Protected><DisplayUserPlanDetails/></Protected> },
    // { path: "/subscription", element:<Protected><DisplayUserPlanDetails /></Protected> },
  { path: "/accountSetting", element: <Protected><RestrictedRoute component={GeneralSettings} /></Protected> },
  { path: "/billing", element: <Protected><RestrictedRoute component={Billing} /></Protected> },
  {path : "/cookie-policy",element:<DashboardProtected><CookiePolicy /></DashboardProtected>},
  { path: "/signup", element: <DomainCheck><DashboardProtected><SignUp /></DashboardProtected></DomainCheck> },
  { path: "/login", element: <DomainCheck><DashboardProtected><LoginWrapper /></DashboardProtected></DomainCheck>},
  // { path: "/login", element: <DomainCheck><DashboardProtected><SignUp /></DashboardProtected></DomainCheck>},
  {path:'verify/:token?',element:<VerifyEmail/>},
  {path:'createPassword',element:<CreatePassword/>},
  {path:'forgotPassword/',element:<ForgotPassword/>},
  { path: '/resetPassword/:token?', element: <ResetPassword />},
  { path : "*", element: <NotFoundPage></NotFoundPage> }

];

export default routes;
